import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "articleWarp"
};
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_guideBottom = _resolveComponent("guideBottom");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, _toDisplayString($data.detail.title), 1), _createElementVNode("div", {
    innerHTML: $data.detail.content
  }, null, 8, _hoisted_2), _ctx.$route.query.fid == 152288 ? (_openBlock(), _createBlock(_component_guideBottom, {
    key: 0
  })) : _createCommentVNode("", true)]);
}